<style>
#CurveDetail .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 400px !important;
}
#CurveDetail .v-card.v-card--flat.v-sheet.theme--light {
  height: 100% !important;
}
#CurveDetail .current-curve__header {
  font-size: 15px;
  font-weight: 500;
}
#CurveDetail .header__text--center {
  text-align: center;
}
#CurveDetail .header__first-row {
  line-height: 68px;
}
#CurveDetail .full-height {
  height: 90%;
}
#CurveDetail .v-input {
  font-size: 12px;
}
#CurveDetail .chartContainer {
  width: 100%;
  height: 90%;
}
</style>

<template>
  <Modal
    modalName="CurveDetail"
    :editing="editing"
    :title="chartType == 'line' ? 'Szczegóły krzywej' : 'Szczegóły wzorca'"
    @editingCancel="cancelEditing()"
    @editingSave="saveEditing()"
    @editingStart="startEditing()"
    @opened="computeChartData"
    @closed="close"
    :buttons="[]"
    :module="module"
  >
    <v-layout
      class="header__first-row"
      v-if="chartType == 'line'"
    >
      <v-flex
        xs3
        class="header__text--center"
      >
        <v-text-field
          class="current-curve__header"
          label="ID"
          v-model="currentCurve.curve_id"
          :readonly="!editing"
        ></v-text-field>
      </v-flex>
      <v-spacer />
      <v-flex
        xs3
        class="header__text--center"
      >
        <v-text-field
          class="current-curve__header"
          label="Opis"
          v-model="currentCurve.description"
          :readonly="!editing"
        ></v-text-field>
      </v-flex>
      <v-spacer />
      <v-flex xs3>
        <v-select
          :items="curvesTypes"
          v-model="curveType"
          @change="changeCurve"
          label="Rodzaj krzywej"
          append-icon=""
          style="pointer-events:none"
          readonly
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout
      class="header__first-row"
      v-else
    >
      <v-flex
        xs5
        class="header__text--center"
      >
        <v-text-field
          class="current-curve__header"
          label="ID"
          v-model="currentCurve.curve_id"
          :readonly="!editing"
        ></v-text-field>
      </v-flex>
      <v-spacer />
      <v-flex
        xs5
        class="header__text--center"
      >
        <v-text-field
          class="current-curve__header"
          label="Opis"
          v-model="currentCurve.description"
          :readonly="!editing"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout class="full-height">
      <v-flex xs4>
        <SingleCurveTable :currentCurve="currentCurve" style="height:75%"/>
        <v-btn
          dark
          color="rgb(42, 87, 154)"
          @click="addCurveRow"
          title="Po dodaniu wiersza w tabeli należy wpisać wartości w odpowiednich kolumnach. W celu wykonania edycji trzeba kliknąć dwukrotnie lewym przyciskiem myszy w komórce tabeli."
          style="margin-left: 0px"
        >DODAJ WIERSZ</v-btn><br/>
        <small>Po dodaniu wiersza w tabeli należy wpisać...</small><v-icon small  title="Po dodaniu wiersza w tabeli należy wpisać wartości w odpowiednich kolumnach. W celu wykonania edycji trzeba kliknąć dwukrotnie lewym przyciskiem myszy w komórce tabeli.">help</v-icon>
      </v-flex>
      <v-spacer />
      <v-flex xs7>
        <canvas
          v-show="isChartVisible"
          id="curveChart"
        ></canvas>
        <div
          v-show="!isChartVisible"
          class="chartContainer"
          style="display:flex;justify-content:center;align-items:center"
        >
          Brak wykresu
        </div>
      </v-flex>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal';
import SingleCurveTable from '../../table/curves/SingleCurveTable';
import regression from 'regression';
import Chart from "chart.js";

export default {
  components: {
    Modal,
    SingleCurveTable
  },
  data: () => ({
    currentCurve: {},
    currentCurveCopy: {},
    curvesTypes: ['VOLUME', 'PUMP', 'EFFICIENCY', 'HEADLOSS'],
    chartType: undefined,
    curveType: undefined,
    editing: false,
    isChartVisible: true,
    noDataMsg: 'Brak opisu',
    module: 'curves'
  }),
  methods: {
    cancelEditing() {
      this.editing = false;
      this.currentCurve = this.currentCurveCopy;
    },
    saveEditing() {
      let payload = {
        oid: this.currentCurve.id,
        body: {
          curve_id: this.currentCurve.curve_id,
          curve_type: this.currentCurve.curve_type,
          data: this.currentCurve.data,
          description: this.currentCurve.description
        }
      }
      this.$store.dispatch("editCurveValues", payload).then(r => {
        if(r) {
          this.$root.$emit("refreshCurves");
          this.$root.$emit("refreshPatterns");
          this.editing = false;
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            `${r}`
          );
        }
      });
    },
    startEditing() {
      this.editing = true;
      this.currentCurveCopy = this.currentCurve;
    },
    changeCurve(data) {
      if(data === 'VOLUME') {
        this.currentCurve.curve_type = 1
      } else if(data === 'PUMP') {
        this.currentCurve.curve_type = 2
      } else if(data === 'EFFICIENCY') {
        this.currentCurve.curve_type = 3
      } else if(data === 'HEADLOSS') {
        this.currentCurve.curve_type = 4
      }
      this.loadCurve(this.currentCurve);
      this.computeChartData();

      let payload = {
        oid: this.currentCurve.id,
        body: {
          curve_id: this.currentCurve.curve_id,
          curve_type: this.currentCurve.curve_type,
          data: this.currentCurve.data,
          description: this.currentCurve.description
        }
      }
      this.$store.dispatch("editCurveValues", payload).then(r => {
        if(r) {
          this.$root.$emit("refreshCurves")
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            `${r}`
          );
        }
      });
    },
    addCurveRow() {
      this.$root.$emit('createNewRow');
    },
    loadCurve(data) {
      this.currentCurve = data;
      if(data.curve_type === 1) {
        this.curveType = 'VOLUME'
      } else if(data.curve_type === 2) {
        this.curveType = 'PUMP'
      } else if(data.curve_type === 3) {
        this.curveType = 'EFFICIENCY'
      } else if(data.curve_type === 4) {
        this.curveType = 'HEADLOSS'
      }

      if((this.currentCurve.data.length === 1 && this.currentCurve.data[0].x !== 0) || this.currentCurve.data.length === 3) {
        let points = this.countReg(data);
      }
    },
    computeChartData() {
      let elementsNumber = this.currentCurve.data.length;
      if(elementsNumber == 0) {
        this.isChartVisible = false;
        return;
      }
      let data = [];
      let labels = [];
      this.chartType = this.currentCurve.curve_type === 0 ? 'bar' : 'line';
      let labString = 'Efficiency (%)'

      if(this.curveType !== 'PUMP') {
        if(elementsNumber === 1) {
          this.isChartVisible = false;
        } else {
          for(let el of this.currentCurve.data) {
            labels.push(el.x);
            data.push(el.y);
          }
          this.drawChart(labels, data, labString);
        }
      } else {
        if(elementsNumber === 2 || elementsNumber > 4) {
          for(let el of this.currentCurve.data) {
            labels.push(el.x);
            data.push(el.y);
          }
          this.drawChart(labels, data, labString);
        } else if(elementsNumber === 1 && this.currentCurve.data[0].x === 0) {
          this.isChartVisible = false;
        }
        else if((elementsNumber === 1 && this.currentCurve.data[0].x !== 0) || elementsNumber === 3) {
          labString = 'Head (m)';
          let points = this.countReg(this.currentCurve);
          for(let el of points) {
            labels.push(el.x);
            data.push(el.y);
          }
          this.drawChart(labels, data, labString);
        }
      }
    },
    drawChart(labels, data, labString) {
      this.isChartVisible = true;
      var ctx = document.getElementById('curveChart').getContext('2d');
      var myChart = new Chart(ctx, {
        type: this.chartType,
        data: {
          labels: labels,
          datasets: [{
            data: data,
            fill: false,
            lineTension: 1,
            borderColor: '#2a579a',
            backgroundColor: '#2a579a'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          elements: {
            point: {
              radius: 0
            }
          },
          tooltips: {
            enabled: this.chartType == 'line' ? false : true
          },
          scales: {
            yAxes: [{
              ticks: {
                callback: function (value, index, values) {
                  return parseFloat(value).toFixed(1);
                },
                autoSkip: true,
                stepSize: Math.max(...data) < 1 ? 0.1 : 5,
                max: Math.max(...data) < 1 ? Math.max(...data) : Math.ceil(Math.max(...data) / 5) * 5,
                min: 0
              },
              scaleLabel: {
                display: true,
                labelString: this.chartType == 'line' ? labString : "Współczynnik"
              }
            }],
            xAxes: [{
              ticks: {
                callback: function (value, index, values) {
                  return parseFloat(value).toFixed(1);
                },
                autoSkip: true,
                stepSize: Math.max(...labels) < 1 ? 0.1 : 5,
                max: Math.max(...labels) < 1 ? Math.max(...labels) : Math.ceil(Math.max(...labels) / 5) * 5,
                min: 0
              },
              scaleLabel: {
                display: true,
                labelString: this.chartType == 'line' ? 'Flow (CMH)' : 'Czas'
              }
            }]
          }
        }
      });
    },
    countReg(data) {
      data = data.data;
      if(data.length == 1) {
        //Dla jednego punktu wyznaczamy dwa sąsiadujące
        var one = [0, data[0].x * 1.33334];
        var two = [data[0].x, data[0].y];
        var three = [data[0].x * 2, 0];
      } else if(data.length == 3) {
        var one = [data[0].x, data[0].y];
        var two = [data[1].x, data[1].y];
        var three = [data[2].x, data[2].y];
      } else {
        // console.log('Błędne dane');
        return
      }
      //Regresja metodą najmniejszych kwadratów
      let poly = regression.polynomial([one, two, three]);
      let a = poly.equation[0];
      let b = poly.equation[1];
      let c = poly.equation[2];
      //Obliczenie pomocnicznych punktów do narysowania wykresu
      let result = [];
      let n_vals = 30;
      for(let i = 0; i <= n_vals; i++) {
        let x = (three[0] - one[0]) / n_vals * i;
        let y = a * Math.pow(x, 2) + b * x + c;
        result.push({x: x, y: y});
      }
      return result
    },
    close() {
      this.curveType = undefined;
      this.currentCurve = {};
    }
  },
  mounted() {
    this.$root.$on('loadCurve', this.loadCurve);
    this.$root.$on('computeChartData', this.computeChartData);
  }

}
</script>


// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/CurveDetail.vue